import { render, staticRenderFns } from "./dealerList.vue?vue&type=template&id=23b27698&scoped=true&"
import script from "./dealerList.vue?vue&type=script&lang=js&"
export * from "./dealerList.vue?vue&type=script&lang=js&"
import style0 from "./dealerList.vue?vue&type=style&index=0&id=23b27698&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b27698",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23b27698')) {
      api.createRecord('23b27698', component.options)
    } else {
      api.reload('23b27698', component.options)
    }
    module.hot.accept("./dealerList.vue?vue&type=template&id=23b27698&scoped=true&", function () {
      api.rerender('23b27698', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/budget/cost_warning_ratio_configuration/form/components/dealerList.vue"
export default component.exports